import React from 'react'
import { ArrowRight } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'

const AppointmentLandingPage = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img grid-center p-top-bottom2rem1 px-md-0 px-4' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/12/ULC-Testing-bg-v1.png")',}}>
        <div className='mt-md5 mt4'>
            <div className='fs-ss-30-2 text-montserrat fw-600 text-ss-black'>
                Welcome to United Lab Care
            </div>
        </div>
        
        <div className='py-3'>
            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Book your appointment in few steps, select the test type for which you want to book appointment.
            </div>
        </div>

            <Row className=''>
                <Col className='mb-md-0 mb-4'>
                    <Link to='/toxicology-test-appointment' style={{ textDecoration:'none'}} >
                    <div className='' style={{ display:'flex'}}>
                        <div className='' style={{ backgroundColor:'#EB242B', padding:'1rem'}}>
                            <ArrowRight className='text-white fs-ss-24 fw-7' style={{ fontWeight:700}}/>
                        </div>
                        <div className='' style={{ width:'280px'}}>
                            <div className='fs-ss-18 text-montserrat fw-600 text-white flex-center' style={{ backgroundColor:'#1070AA', padding:'1rem'}}>
                                Book Toxicology Test
                            </div>
                        </div>
                    </div>
                        </Link>
                </Col>
                <Col className='mb-md-0 mb-4'>
                <Link to='/general-blood-test-appointment' style={{ textDecoration:'none'}} >
                    <div className='' style={{ display:'flex'}}>
                        <div className='' style={{ backgroundColor:'#EB242B', padding:'1rem'}}>
                            <ArrowRight className='text-white fs-ss-24 fw-7' style={{ fontWeight:700}}/>
                        </div>
                        <div className='' style={{ width:'280px'}}>
                            <div className='fs-ss-18 text-montserrat fw-600 text-white flex-center' style={{ backgroundColor:'#1070AA', padding:'1rem'}}>
                                Book Blood Test
                            </div>
                        </div>
                    </div>
                    </Link>
                </Col>
                <Col className='mb-md-0 mb-4'>
                <Link to='/sti-std-test-appointment' style={{ textDecoration:'none'}} >
                    <div className='' style={{ display:'flex'}}>
                        <div className='' style={{ backgroundColor:'#EB242B', padding:'1rem'}}>
                            <ArrowRight className='text-white fs-ss-24 fw-7' style={{ fontWeight:700}}/>
                        </div>
                        <div className='' style={{ width:'280px'}}>
                            <div className='fs-ss-18 text-montserrat fw-600 text-white flex-center' style={{ backgroundColor:'#1070AA', padding:'1rem'}}>
                                Book STI/HIV Test
                            </div>
                        </div>
                    </div>
                    </Link>
                </Col>
            </Row>
            
            <Row className='mt-md-5 mt4 mb-md-5'>
                <Col md='4' className='mb-md-0 mb-4'>
                <Link to='/book-panel-test-appointment' style={{ textDecoration:'none'}} >
                    <div className='' style={{ display:'flex'}}>
                        <div className='' style={{ backgroundColor:'#EB242B', padding:'1rem'}}>
                            <ArrowRight className='text-white fs-ss-24 fw-7' style={{ fontWeight:700}}/>
                        </div>
                        <div className='' style={{ width:'280px'}}>
                            <div className='fs-ss-18 text-montserrat fw-600 text-white flex-center' style={{ backgroundColor:'#1070AA', padding:'1rem'}}>
                                Book Panel Test
                            </div>
                        </div>
                    </div>
                    </Link>
                </Col>
                <Col className='mb-md-0 mb-4'>
                <Link to='/book-covid-test-appointment' style={{ textDecoration:'none'}} >
                    <div className='' style={{ display:'flex'}}>
                        <div className='' style={{ backgroundColor:'#EB242B', padding:'1rem'}}>
                            <ArrowRight className='text-white fs-ss-24 fw-7' style={{ fontWeight:700}}/>
                        </div>
                        <div className='' style={{ width:'280px'}}>
                            <div className='fs-ss-18 text-montserrat fw-600 text-white flex-center' style={{ backgroundColor:'#1070AA', padding:'1rem'}}>
                                Book Covid Test
                            </div>
                        </div>
                    </div>
                    </Link>
                </Col>
                
            </Row>
        </div>
    </div>
  )
}

export default AppointmentLandingPage